import { useRef, useEffect, useState, use } from 'react';
import style from './Sec01.module.css';


function Sec01() {

    return (
        <div className={style.wrap}>
            <div>
                <h3>
                    우리는 단순한 생산이 아닌<br />
                    <span>고객 만족</span>을 위한<br />
                    결과를 만들어냅니다.
                </h3>
            </div>
        </div>
    )
}

export default Sec01;